module.exports = __webpack_public_path__ + "img/exterieur-lazy.703da851.jpg";